import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";

import api from "../../services/api";
import openSocket from "../../services/socket-io";
import { i18n } from "../../translate/i18n";

// Total de mensagens não lidas do chat interno + aviso de mensagem nova
// quando o usuário não está na tela do chat
const useInternalChatUnreads = (user, location, history) => {
  const [unreads, setUnreads] = useState({});
  const pathRef = useRef(location.pathname);

  useEffect(() => {
    pathRef.current = location.pathname;
  }, [location.pathname]);

  useEffect(() => {
    if (!user.id) return undefined;

    (async () => {
      try {
        const { data } = await api.get("/chats");
        setUnreads(Object.fromEntries(data.map((c) => [c.id, c.unreads])));
      } catch (err) {
        // O contador é opcional; a tela do chat mostra os erros
      }
    })();

    const socket = openSocket();
    socket.on("chat", (data) => {
      if (data.action === "delete") {
        setUnreads((prev) => {
          const next = { ...prev };
          delete next[data.chatId];
          return next;
        });
        return;
      }

      setUnreads((prev) => ({ ...prev, [data.chat.id]: data.chat.unreads }));

      const { message } = data;
      if (
        data.action === "message" &&
        message.senderId !== user.id &&
        !pathRef.current.startsWith("/chats")
      ) {
        toast.info(
          i18n.t("internalChat.newMessage", {
            name: message.sender?.name,
            body: message.body.slice(0, 80),
          }),
          { onClick: () => history.push(`/chats/${data.chat.id}`) }
        );
      }
    });

    return () => socket.disconnect();
  }, [user.id, history]);

  return Object.values(unreads).reduce((sum, n) => sum + (n || 0), 0);
};

export default useInternalChatUnreads;
